import { AxiosResponse } from "axios";
import API from "../api";
import { Notification } from "../models/notification";

import BaseService from "./_base.service";

const endpoint = "fileimporthistory";

export const FileImportHistoryService = {
  ...BaseService<any>({ endpoint }),
  async findByTableName(options?: any): Promise<AxiosResponse<any[]>> {
    return await API.get(`/${endpoint}/findByTableName`, { params: options });
  },
};
